module.exports = __webpack_public_path__ + "img/tervezhetoseg_bg_768.c0a7035b.png";